/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/**********************************************************************************************************
 *    SLICE
 **********************************************************************************************************/
export const domainSlice = createSlice({
    name: 'domain',
    initialState: {
        dnsMode: ''
    },
    reducers: {
        setDNSMode: (state, action: PayloadAction<string>) => {
            state.dnsMode = action.payload
        }
    }
})

export const { setDNSMode } = domainSlice.actions
export default domainSlice.reducer
